import axios from "axios";

// ===========================================
// CREATE AXIOS INSTANCE
// ===========================================
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || "https://your-backend-url.com/api",
  timeout: 20000,
  withCredentials: true, // optional (cookies / sessions)
});

// ===========================================
// TOKEN HANDLING
// ===========================================
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ===========================================
// RESPONSE INTERCEPTOR (AUTO REFRESH TOKEN)
// ===========================================
let isRefreshing = false;
let queue = [];

const processQueue = (error, token = null) => {
  queue.forEach((prom) => {
    error ? prom.reject(error) : prom.resolve(token);
  });

  queue = [];
};

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If token expired
    // if (error.response?.status === 401 && !originalRequest._retry) {
    //   if (isRefreshing) {
    //     return new Promise((resolve, reject) => {
    //       queue.push({ resolve, reject });
    //     })
    //       .then((token) => {
    //         originalRequest.headers["Authorization"] = "Bearer " + token;
    //         return api(originalRequest);
    //       })
    //       .catch((err) => Promise.reject(err));
    //   }

    //   originalRequest._retry = true;
    //   isRefreshing = true;

    //   try {
    //     const refreshToken = localStorage.getItem("refresh_token");
    //     const res = await axios.post(
    //       `${import.meta.env.VITE_API_URL}/auth/refresh`,
    //       { refresh_token: refreshToken }
    //     );

    //     const newToken = res.data.access_token;
    //     localStorage.setItem("access_token", newToken);

    //     api.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;
    //     processQueue(null, newToken);

    //     return api(originalRequest);
    //   } catch (err) {
    //     processQueue(err, null);
    //     return Promise.reject(err);
    //   } finally {
    //     isRefreshing = false;
    //   }
    // }

    return Promise.reject(error);
  }
);

// ===========================================
// GENERIC API HANDLERS
// ===========================================
export const apiGet = (url, params = {}) => api.get(url, { params });

export const apiPost = (url, body) => api.post(url, body);

export const apiPut = (url, body) => api.put(url, body);

export const apiPatch = (url, body) => api.patch(url, body);

export const apiDelete = (url) => api.delete(url);

// ===========================================
// FILE UPLOAD (Any Type - Image/Docs)
// ===========================================
export const apiUpload = (url, file, fieldName = "file") => {
  const formData = new FormData();
  formData.append(fieldName, file);

  return api.post(url, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// ===========================================
// EXPORT
// ===========================================
export default api;
